import { render, staticRenderFns } from "./ReceiverEdit.vue?vue&type=template&id=0c211634"
import script from "./ReceiverEdit.vue?vue&type=script&lang=js"
export * from "./ReceiverEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports